
import React from "react";
import EBooks from '../Components/Dashboard/Resource-Center/E-Books';
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
const AuthEBooks = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <EBooks /> : <SessionTimeoutRedirect />
}
export default AuthEBooks;


